import React, {useState } from 'react'
import "./tablestyle.scss";

import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { Link } from 'react-router-dom';
import { SortDescriptor } from '@progress/kendo-data-query';
import { Icon } from "@iconify/react";



const InContract = (Props: any) => {

  
  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  const candidateName = (props: GridCellProps) => {
    let candidateName = props.dataItem.candidateName.split(' ');
    return (
        <td>
          <div className="userInfo">
          <figure>{candidateName[0][0] + candidateName[1][0]}</figure>
            {props.dataItem.candidateName}
          </div>
        </td>
    )
  }
 
  const viewButton = (data: any) => {
    localStorage.setItem('candidateData', JSON.stringify(data))
  }

  const viewTimeSheet = (props: GridCellProps) => {
    return (
        <td >
        <Link style={{ 'color': 'green' }} onClick={() =>viewButton(props.dataItem)} to={'/timesheet'} state={{state:props.dataItem}}> View Timesheet </Link>
        </td>
    )
}


  const contractDurationCell = (props: GridCellProps) => {
    return (
      <td>
        {new Date(parseInt(props.dataItem.contractStartDate)).toDateString().slice(3) + ' - ' + new Date(parseInt(props.dataItem.contractEndDate)).toDateString().slice(3)}
    </td>
  )
}


    return (
        <>
        <Grid
          data={Props.state.items}
          sortable={true}
          sort={sort}
          onSortChange={(e) => {
            setSort(e.sort);
           Props.setSort(e.sort);
           Props.applySort(e.sort);
          }}
        >
          <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
          </GridNoRecords>
          <Column cell={candidateName} field='candidateName' title="Name" width="180" className="noWordWrap"  />
          <Column field="jobRole" title="Job Role"  />
          <Column field="companyName" title="Company"  />
          <Column field="contractDuration" title="Contract Duration" cell={contractDurationCell} />
          <Column cell={viewTimeSheet} width="125px"/>
          </Grid>
         
          </>
 )
}

export default InContract